import { fromJS, Map } from 'immutable';
import { groupListBy } from 'flow/utils';
import Actions from 'flow/actions';

const initialState = Map();

export const UserCredentialReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.RESULT_USER_CREDENTIALS: {
            const userCredentials = fromJS(action.data);
            const filteredCredentials = groupListBy(userCredentials, (item) =>
                item.get('type'),
            );
            return state.set(action.key, filteredCredentials);
        }
        case Actions.SET_USER_CREDENTIALS_SUCCESS: {
            return state.set('successUserCredential', action.value);
        }
        case Actions.SET_USER_CREDENTIAL_FAILURE: {
            return state.set('updateFailureReason', action.value);
        }
        default: {
            return state;
        }
    }
};

export default UserCredentialReducer;
